export const config = {
  customerLoginUrl: "https://prod.crescentexchange.com/",
  agentLoginUrl: "https://prodagent.crescentexchange.com/",
};
